import {motion, useTransform, useScroll} from "framer-motion";
import React, {useRef} from "react";
import {HiArrowRight} from "react-icons/hi2";
import {BsArrow90DegRight} from "react-icons/bs";

const HorizontalScrollCarousel = () => {
    const targetRef = useRef(null);
    const {scrollYProgress} = useScroll({
        target: targetRef,
    });

    const x = useTransform(scrollYProgress, [0, 1], ["7.5%", "-88%"]);

    return (
        <section ref={targetRef} className="relative h-[300vh] ">
            <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                <motion.div style={{x}} className="flex gap-4">
                    {cards.map((card) => {
                        return <Card card={card} key={card.id}/>;
                    })}
                </motion.div>
            </div>
        </section>
    );
};

const Card = ({card}) => {
    return (<div
        key={card.id}
        className="group relative h-screen overflow-hidden flex items-center"
    >
        <div className="flex">
            <motion.div
                className="px-4 w-[40rem] py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto"
                variants={{
                    hidden: { opacity: 0, x: -50 },
                    visible: { opacity: 1, x: 0 }
                }}
                initial="hidden"
                whileInView="visible"
                transition={{duration: 0.6, delay: 0.4}}
                viewport={{once: false}}
            >
                <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                    <img className="h-80 w-full object-cover object-center opacity-50"
                         src="https://dummyimage.com/800x600" alt="blog"/>
                    <div className="p-6">
                        <h2 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">
                            { card.category }
                        </h2>
                        <h1 className="title-font text-2xl font-bold text-blue-600 mb-3">
                            { card.summary }
                        </h1>
                        <p className="leading-relaxed mb-3">
                            { card.addition }
                        </p>
                        <div className="flex items-center flex-wrap">
                            <div className="text-slate-400 hover:text-slate-500 inline-flex items-center md:mb-2 lg:mb-0">
                                Learn More
                                <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor"
                                     stroke-width="2" fill="none" stroke-linecap="round"
                                     stroke-linejoin="round">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5l7 7-7 7"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>
            { card.id!==7 ?
                <motion.div
                    className="text-6xl my-auto ml-20 mr-16"
                    variants={{
                        hidden: { opacity: 0, x: -50 },
                        visible: { opacity: 1, x: 0 }
                    }}
                    initial="hidden"
                    whileInView="visible"
                    transition={{duration: 0.6, delay: 0.8}}
                    viewport={{once: false}}
                >
                    <HiArrowRight />
                </motion.div> :
                <motion.div
                    className="my-auto text-6xl ml-24"
                    variants={{
                        hidden: { opacity: 0, y: -50 },
                        visible: { opacity: 1, y: 0 }
                    }}
                    initial="hidden"
                    whileInView="visible"
                    transition={{duration: 0.6, delay: 0.8}}
                    viewport={{once: false}}
                >
                    <BsArrow90DegRight className="rotate-90" />
                </motion.div> }
        </div>
    </div>);
};

const cards = [
    {
        category: "Category No.1",
        summary: "Summary of outcome No.1",
        addition: "Some additional information for outcome No.1",
        id: 1
    },
    {
        category: "Category No.2",
        summary: "Summary of outcome No.2",
        addition: "Some additional information for outcome No.2",
        id: 2
    },
    {
        category: "Category No.3",
        summary: "Summary of outcome No.3",
        addition: "Some additional information for outcome No.3",
        id: 3
    },
    {
        category: "Category No.4",
        summary: "Summary of outcome No.4",
        addition: "Some additional information for outcome No.4",
        id: 4
    },
    {
        category: "Category No.5",
        summary: "Summary of outcome No.5",
        addition: "Some additional information for outcome No.5",
        id: 5,
    },
    {
        category: "Category No.6",
        summary: "Summary of outcome No.6",
        addition: "Some additional information for outcome No.6",
        id: 6,
    },
    {
        category: "Category No.7",
        summary: "Summary of outcome No.7",
        addition: "Some additional information for outcome No.7",
        id: 7,
    }
];

export default function HorizontalScrollOutcome() {
    return (
        <HorizontalScrollCarousel/>
    )
}